import { render, staticRenderFns } from "./MealEditor.vue?vue&type=template&id=97af659c&scoped=true&"
import script from "./MealEditor.vue?vue&type=script&lang=js&"
export * from "./MealEditor.vue?vue&type=script&lang=js&"
import style0 from "./MealEditor.vue?vue&type=style&index=0&id=97af659c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97af659c",
  null
  
)

export default component.exports